import React from "react";

export default function Help(){
    return (
        <div className="fixed bottom-4 right-4 z-60 flex items-center justify-center">
          <a 
            href="https://wa.me/6285329075397" 
            target="_blank"
          >
            <button className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                <i className="fab fa-whatsapp"></i> Chat with us
            </button>
          </a>
        </div>
      );
}